import React, { Component } from "react";
import { properties } from "../../constants/Propertise";
import { api } from "../../api/api";
import Overlay from "../Overlay";
import { forgotpPasswordConfig } from "../../constants/themeConfig";
import InlineError from "../InlineError";
import { Fragment } from "react";
import { Input } from "reactstrap";
import ResetPasswordPage from "./ResetPasswordPage";
import { connect } from "react-redux";
import { forgotPassword } from "../../Reducers/Login/ForgotPasswordReducer";
import { CommonMethods } from "../Common/CommonMethod";
import { history } from "../../history";

class ForgetPasswordOTPPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: {},
      otp: "",
      time: {},
      resendOptButton: false,
      username: this.props.username,
      // userPhoneNumber: this.props.userInformation.phoneNumber,
      resetTime: forgotpPasswordConfig[0].optResetTime,
      sessionResetTime: forgotpPasswordConfig[0].sessionResetTime,
      showPending: false,
      showError: false,
      showSucess: false,
      apiError: "",
      style: {
        background: "transparent",
        color: "#71748d",
        border: "none",
        outline: "none",
        padding: "0px",
        borderBottom: "1px solid",
        width: "100%",
        fontFamily: "sans-serif",
      },
      seconds: 30,
      disableResendOTPButton: false,
      passwordDetails: {
        password: "",
        confirmPassword: "",
      },
    };

    this.timer = 0;
    this.startTimer = this.startTimer.bind(this);
    this.countDown = this.countDown.bind(this);
  }

  handelOptChange = (event) => {
    this.setState({
      ...this.state.otp,
      otp: event.target.value,
    });
  };

  validate = (data) => {
    const errors = {};
    if (!data.otp) {
      errors.otp = properties.otpRequired;
    }

    if (!data.password) {
      errors.password = properties.newPasswordRequired;
    } else {
      let isvalidPassword = CommonMethods.checkPassword(data.password);
      if (isvalidPassword === false) {
        errors.password = properties.newPasswordNotMatchCriteria;
      }
    }
    if (!data.confirmPassword) {
      errors.confirmPassword = properties.confirmPasswordRequired;
    } else if (data.password !== data.confirmPassword) {
      errors.confirmPassword = properties.newConfirmPasswordSame;
    }

    return errors;
  };

  handleSubmit = (event) => {
    event.preventDefault();
    const formData = {
      username: this.props.username,
      otp: this.state.otp,
      password: this.state.passwordDetails.password,
      confirmPassword: this.state.passwordDetails.confirmPassword,
    };

    const errors = this.validate(formData);
    this.setState({ errors }, () => {
      if (Object.keys(errors).length === 0) {
        let apiPayload = {
          username: this.props.username,
          newPassword: this.state.passwordDetails.password,
        };
        this.validateOtp(apiPayload);
      }
    });
  };

  handleChange = (event) => {
    this.setState({
      passwordDetails: {
        ...this.state.passwordDetails,
        [event.target.name]: event.target.value,
      },
    });
  };

  validateOtp = (forgetPasswordUserData) => {
    this.setState({
      showPending: true,
      showError: false,
      apiError: "",
    });

    let validatOtpUrl = `${process.env.REACT_APP_API_URL}forgotPassword/validateOTPAndResetPassword/${this.state.otp}`;
    api
      .post(validatOtpUrl, forgetPasswordUserData)
      .then((validatOtpResult) => {
        if (validatOtpResult.status === 200) {
          if (validatOtpResult.data === "Invalid OTP!") {
            const errors = {};
            errors.otp = validatOtpResult.data;
            this.setState({
              showPending: false,
              showError: false,
              errors: errors,
            });
          } else {
            this.setState({
              showPending: false,
              showError: false,
              showSucess: true,
            });
          }
        } else {
          this.setState({
            showPending: false,
            showError: true,
            apiError: properties.globalErrorMessage,
            showSucess: false,
          });
        }
      })
      .catch((validatOtpError) => {
        this.setState({
          showPending: false,
          showError: true,
          apiError: properties.globalErrorMessage,
          showSucess: false,
        });
      });
  };

  componentDidMount() {
    this.startTimer();
    let timeLeftVar = this.secondsToTime(this.state.seconds);
    this.setState({ time: timeLeftVar });
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.disableResendOTPButton !== this.state.disableResendOTPButton
    ) {
      if (this.state.disableResendOTPButton) {
        this.restartTimer();
      }
    }

    if (prevState.showSucess !== this.state.showSucess) {
      if (this.state.showSucess === true) {
        setTimeout(() => {
          window.location.reload();
          history.push(`${process.env.PUBLIC_URL}/login`);
        }, 1000);
      }
    }
  }

  secondsToTime(secs) {
    let hours = Math.floor(secs / (60 * 60));

    let divisor_for_minutes = secs % (60 * 60);
    let minutes = Math.floor(divisor_for_minutes / 60);

    let divisor_for_seconds = divisor_for_minutes % 60;
    let seconds = Math.ceil(divisor_for_seconds);

    let obj = {
      h: hours,
      m: minutes,
      s: seconds,
    };

    return obj;
  }

  startTimer() {
    if (this.timer === 0 && this.state.seconds > 0) {
      this.timer = setInterval(this.countDown, 1000);
    }
  }

  countDown() {
    // Remove one second, set state so a re-render happens.
    let seconds = this.state.seconds - 1;
    this.setState({
      time: this.secondsToTime(seconds),
      seconds: seconds,
    });

    // Check if we're at zero.
    if (seconds === 0) {
      clearInterval(this.timer);
      // this.props.showResendOpt();
      this.setState({
        disableResendOTPButton: false,
      });
    }
  }

  restartTimer = () => {
    this.setState(
      {
        seconds: this.state.seconds,
      },
      () => {
        this.timer = 0;
        this.startTimer();
      }
    );
  };

  stopTimer = () => {
    clearInterval(this.timer);
    this.setState({ seconds: 0 }, () => {
      this.timer = 0;
    });
  };

  handleResendOTP = () => {
    let resendOtpUrl =
      process.env.REACT_APP_API_URL + "OTP/v1/emailOTP";
    // let resendOtpUrl = process.env.REACT_APP_API_URL + "OTP/v1/emailOTP";
    this.setState({
      disableResendOTPButton: true,
      seconds: 30,
    });
    const resendOtpReqBody = {
      username: this.props.username,
    };
    api
      .post(resendOtpUrl, resendOtpReqBody)
      .then((resendOtpResult) => {
        if (resendOtpResult.data !== "undefined") {
          this.setState({
            inpageLoadingError: false,
            inpageLoadingPending: false,
            inpageLoadingSucess: true,
            showInPageAlertModel: true,
            message: resendOtpResult.data,
          });

          setTimeout(() => {
            if (this.state.inpageLoadingSucess === true) {
              this.setState({
                showInPageAlertModel: false,
              });
            }
          }, 1000);
        } else {
          this.setState({
            inpageLoadingError: true,
            inpageLoadingPending: false,
            inpageLoadingSucess: false,
            showInPageAlertModel: true,
            message: properties.globalErrorMessage,
          });
        }
      })
      .catch((error) => {
        this.setState({
          inpageLoadingError: true,
          inpageLoadingPending: false,
          inpageLoadingSucess: false,
          showInPageAlertModel: true,
          message: properties.globalErrorMessage,
        });
      });
  };

  render() {
    return (
      <Fragment>
        <div className="mb-3">
          {this.state.showPending === true && (
            <div className="form-row">
              <div className="col-md-12 mb-3">
                <div
                  className="alert alert-info alert-dismissible"
                  role="alert"
                  style={{ textAlign: "center" }}
                >
                  {properties.pleaseWaitText}
                </div>
              </div>
            </div>
          )}
          {this.state.showError === true && (
            <div className="form-row">
              <div className="col-md-12 mb-3">
                <div
                  className="alert alert-danger alert-dismissible"
                  role="alert"
                  style={{ textAlign: "center" }}
                >
                  {this.state.apiError === ""
                    ? properties.globalUserErrorMessage
                    : this.state.apiError}
                </div>
              </div>
            </div>
          )}

          {this.state.showError === false &&
            this.state.showSucess === true &&
            this.state.showPending === false && (
              <div className="form-group col-md-12">
                <div
                  className="alert alert-success alert-dismissible"
                  role="alert"
                  style={{ textAlign: "center" }}
                >
                  {properties.forgotpasswordChangeSucess}
                </div>
              </div>
            )}

          <div className="form-row">
            <div className="col-md-12 mb-3" style={{ color: "green" }}>
              {properties.otpSentUpdatedText}
            </div>
          </div>

          <form onSubmit={this.handleSubmit.bind(this)} autoComplete="off">
            <div className="form-row">
              <div className="col-md-10 mb-3">
                <label className="feildName">
                  {properties.username} <span className="required">*</span>:
                </label>
                <Input
                  disabled
                  type="text"
                  name="username"
                  id="username"
                  value={this.state.username}
                  placeholder="Username"
                />
                {this.state.errors.username && (
                  <InlineError text={this.state.errors.username} />
                )}
              </div>

              <div className="col-md-6 mb-3">
                <label className="feildName">
                  {properties.Otptext} <span className="required">*</span>:
                </label>
                <Input
                  type="text"
                  name="otp"
                  value={this.state.otp}
                  onChange={this.handelOptChange}
                  valid={
                    this.state.errors.otp === undefined &&
                    this.state.otp !== "" &&
                    this.state.isValid === true
                      ? true
                      : false
                  }
                  invalid={this.state.errors.otp !== undefined ? true : false}
                />
                {this.state.errors.otp && (
                  <InlineError text={this.state.errors.otp} />
                )}
              </div>

              <div>
                <button
                  className="btn btn-primary pull-right"
                  type="submit"
                  onClick={this.handleResendOTP}
                  disabled={this.state.seconds === 0 ? false : true}
                >
                  {this.state.seconds === 0
                    ? `${properties.resendOtpButtonText}`
                    : `${properties.resendOtpButtonText} (${this.state.time.s} sec)`}
                </button>
              </div>

              <div className="col-md-10 mb-3">
                <label className="feildName">
                  {properties.newPasswordText}{" "}
                  <span className="required">*</span>:
                </label>
                <Input
                  type="password"
                  className="form-control"
                  name="password"
                  value={this.state.passwordDetails.password}
                  onChange={this.handleChange.bind(this)}
                  placeholder={properties.newPasswordText}
                />
                {this.state.errors.password && (
                  <InlineError text={this.state.errors.password} />
                )}
              </div>

              <div className="col-md-10 mb-3">
                <label className="feildName">
                  {properties.confirmPasswordText}{" "}
                  <span className="required">*</span>:
                </label>
                <Input
                  type="password"
                  className="form-control"
                  name="confirmPassword"
                  value={this.state.passwordDetails.confirmPassword}
                  onChange={this.handleChange.bind(this)}
                  placeholder={properties.confirmPasswordText}
                />
                {this.state.errors.confirmPassword && (
                  <InlineError text={this.state.errors.confirmPassword} />
                )}
              </div>
            </div>

            {/* {this.state.seconds !== 0 ? (
              <div className="form-row">
                <div className="col-md-12 text-danger">
                  {properties.linkRegenerate}
                  {this.state.time.s} {properties.secondsText}
                </div>
              </div>
            ) : null} */}
          </form>
        </div>

        <div className="divider" />

        <div>
          <button
            onClick={this.handleSubmit}
            className="btn btn-primary pull-right"
            type="submit"
          >
            Change Password
          </button>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isForgotPasswordSuccess: state.forgotPasswordData.isForgotPasswordSuccess,
    isForgotPasswordPending: state.forgotPasswordData.isForgotPasswordPending,
    forgotPasswordError: state.forgotPasswordData.forgotPasswordError,
    forgotPasswordApiError: state.forgotPasswordData.forgotPasswordApiError,
    forgotPasswordMessage: state.forgotPasswordData.forgotPasswordMessage,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    forgotPassword: (forgotPasswordData, otp) =>
      dispatch(forgotPassword(forgotPasswordData, otp)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ForgetPasswordOTPPage);
